import { LiaHatWizardSolid } from "react-icons/lia";
export default LiaHatWizardSolid;